import { Button } from '@domain-group/suit-theme'

import type { UseOrderPayload } from '@hooks/useOrder'
import useCurrentUser from '@hooks/useCurrentUser'
import { generateUrls } from '@hooks/useCampaignQuote'
import useSelector from '@hooks/useSelector'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'

interface OrderNewItemButtonProps {
  callbacks: {
    addNewOrder: UseOrderPayload['callbacks']['addNewOrder'],
  },
  campaignId: number,
  orderLimitReached: boolean,
}

const OrderNewItemButton = (props: OrderNewItemButtonProps) => {
  const {
    callbacks: { addNewOrder }, campaignId, orderLimitReached,
  } = props

  const { currentUser } = useCurrentUser()

  const campaigns = useSelector(reduxState => reduxState.entities.campaigns)
  const campaign = campaigns && campaignId ? campaigns[campaignId] : {}
  const campaignPermissions = getCampaignPermissions({
    user: currentUser,
    campaignType: getCampaignType(campaign),
  })

  const userCanOrder = campaignPermissions.orders.manage || false
  const requiresQuote = campaignPermissions.orders.require_quote || false

  const { campaignQuotesIndexUrl } = generateUrls(undefined, {
    prefixRoute: `campaigns/${campaignId}/edit`,
  })

  if (!userCanOrder){
    return null
  }

  if (requiresQuote){
    return (
      <Button
        // @ts-expect-error TS2322
        as="a"
        buttonStyle="primaryCreate"
        href={campaignQuotesIndexUrl}
        size="medium"
      >
        Create New Quote
      </Button>
    )
  }

  return (
    <Button
      buttonStyle="primaryCreate"
      disabled={orderLimitReached}
      onClick={() => addNewOrder()}
      size="medium"
      // @ts-expect-error TS2322
      width="auto"
    >
      {orderLimitReached ? 'Max Orders Reached' : 'Order New Item'}
    </Button>
  )
}

export default OrderNewItemButton
